<template>
  <div class="lee-platform-container">
    <el-tabs v-model="active">
      <el-tab-pane label="抖音信息" name="douyin">
        <lee-tiktok />
      </el-tab-pane>
      <el-tab-pane label="快手信息" name="kuaishou">
        <lee-kuaishou />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import LeeTiktok from "./tiktok.vue";
import LeeKuaishou from "./kuaishou.vue";
export default {
  components: {
    LeeTiktok,
    LeeKuaishou,
  },
  data() {
    return {
      active: "douyin",
    };
  },
};
</script>
<style lang="less" scoped>
.lee-platform-container {
  background: #fff;
  padding: 20px 33px;
  :deep(.el-tabs) {
    .el-tabs__nav-wrap::after {
      display: none;
    }
    .el-tabs__item {
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }
    .el-tabs__item.is-active {
      color: #f56c6c;
    }
    .el-tabs__active-bar {
      background-color: #f56c6c;
    }
  }
}
</style>
